/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}backdrop`;
const observedAttributes = {
    VISIBLE: 'visible',
    FIXED: 'fixed'
};
const attributes = {
    ...observedAttributes
};
const classes = {
    ENTERING: 'entering',
    EXITING: 'exiting'
};
const selectors = {
    ROOT: '.forge-backdrop'
};
export const BACKDROP_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    classes,
    selectors
};
